import store from '@/stores/store'

const DFe = () => import(/* webpackChunkName: "dfe" */ '@/components/DFe')
const DFeIndex = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/Index')
const Alert = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/Alert')
const DfeCrossing = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/Crossing')
const DfeCustomReport = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/CustomReport')
const Filing = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/Filing')
const NfseNacional = () => import(/* webpackChunkName: "dfe" */ '@/components/dfe/NfseNacional')

export const dfeRoutes = {
  children: [
    {
      component: DFeIndex,
      meta: {
        breadcrumbs: [{ name: 'DFe' }]
      },
      path: '/'
    },
    {
      component: DfeCrossing,
      meta: {
        breadcrumbs: [
          { link: '/dfes', name: 'DFe' },
          { name: 'Cruzamento' }
        ]
      },
      path: 'crossings'
    },
    {
      component: Alert,
      meta: {
        breadcrumbs: [
          { link: '/dfes', name: 'DFe' },
          { name: 'Alertas' }
        ]
      },
      path: 'alerts'
    },
    {
      component: Filing,
      meta: {
        breadcrumbs: [
          { link: '/dfes', name: 'DFe' },
          { name: 'Arquivados' }
        ]
      },
      path: 'filings'
    },
    {
      component: DfeCustomReport,
      meta: {
        breadcrumbs: [
          { link: '/dfes', name: 'DFe' },
          { dynamicName: () => store.getters.getNameBreadcrumb, name: 'Relatório' }
        ]
      },
      path: 'custom-reports'
    }
  ],
  component: DFe,
  path: 'dfes'
}

export const nfseNacionalRoute = {
  children: [
    {
      component: NfseNacional,
      meta: {
        breadcrumbs: [
          { link: '/dfes', name: 'DFe' },
          { name: 'NFSe Nacional' }
        ]
      },
      path: '/'
    }
  ],
  component: DFe,
  path: 'dfe/documentos_ficais'
}
